import { useEffect } from 'react';

import { useConnectStore } from '../../../../store/models';

function useConnectPlanState () {
    const connectStore = useConnectStore();

    useEffect(() => {
        connectStore.getCurrentPlan();
        connectStore.getPlanDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Change-token: bumps when plans resolve/refresh (availablePlans) or the
    // plan is cancelled/refreshed (currentPlan). Reading it subscribes this
    // observer; the plan value itself comes from the plain currentPlan field.
    const planRevision = `${connectStore.observed.availablePlans}:${connectStore.observed.currentPlan}`;
    const apiPlan = connectStore.currentPlan;
    // Purchase Transactions needs the plan catalog (getPlanDetails) resolved to
    // find the current plan's extra-transactions add-on — gate the trigger
    // button on it, same as UpgradePlanDialog/AddOnsDialog gate their own CTAs.
    const plansResolved = !!connectStore.observed.availablePlans;

    const transactionLimit = Number(apiPlan?.extras?.transactionLimit) || 0;
    const usage = {
        used: Number(apiPlan?.extras?.transactionUsed) || 0,
        total: transactionLimit,
    };
    const plan = apiPlan ? {
        planName: apiPlan.name,
        priceMonthly: Number(apiPlan.price),
        transactionLimit,
        usage,
        status: apiPlan.status,
        nextRenewalDate: apiPlan.nextRenewalDate,
        cancellationScheduledAt: apiPlan.cancellationScheduledAt,
        nextPlanName: apiPlan.nextPlanName,
    } : null;

    return {
        planRevision,
        plan,
        usage,
        plansResolved,
    };
}

export default useConnectPlanState;
